import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'

interface INovelty {
  id: number
  brand: any
  visibility: number
  creator: string
  title: string
  slug: string
  content: string
  image_url: string
  created_at: string
  favoriteId?: number
  highlight?: number
}

export const useNoveltiesPanel = (novelties: INovelty[]) => {
  const dispatch = useDispatch()
  const [highlightNovelties, setHighlightNovelties] = useState<INovelty[]>([])
  const [noHighlightNovelties, setNoHighlightNovelties] = useState<INovelty[]>([])

  useEffect(() => {
    if (novelties.length > 0) {
      const tmpHighlightNovelties = novelties.filter(novelty => novelty.highlight === 1)
      const tmpNoHighlightNovelties = novelties.filter(novelty => novelty.highlight === 0 || novelty.highlight === null)

      setHighlightNovelties(tmpHighlightNovelties)
      setNoHighlightNovelties(tmpNoHighlightNovelties)
    } else {
      setHighlightNovelties([])
      setNoHighlightNovelties([])
    }
  }, [novelties])

  const cutContent = (content: string) => {
    const endIndex = content.indexOf('</p>')
    if (endIndex === -1) return content
    return content.substring(0, endIndex + 4)
  }

  const handleFavoriteClick = (id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id,
          state,
          type: 'novelty',
          favoritefield: 'novelties'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id,
          state,
          type: 'novelty',
          favoritefield: 'novelties'
        })
      )
    }
  }

  return {
    highlightNovelties,
    noHighlightNovelties,
    cutContent,
    handleFavoriteClick
  }
}
